export const BUSINESS_ROUTE = 'business';

export const BusinessRoutePaths = {
  root: `/${BUSINESS_ROUTE}`,
  calendar: `/${BUSINESS_ROUTE}/calendar`,
  appointments: `/${BUSINESS_ROUTE}/appointments`,
  team: `/${BUSINESS_ROUTE}/team`,
  teamNew: `/${BUSINESS_ROUTE}/team/new`,
  teamMember: (id: number | string) => `/${BUSINESS_ROUTE}/team/${id}`,
  settings: `/${BUSINESS_ROUTE}/settings`,
  settingsGeneral: `/${BUSINESS_ROUTE}/settings/general`,
  settingsContact: `/${BUSINESS_ROUTE}/settings/contact`,
  settingsPhoto: `/${BUSINESS_ROUTE}/settings/photo`,
  settingsWorkingHours: `/${BUSINESS_ROUTE}/settings/working-hours`,
  settingsServices: `/${BUSINESS_ROUTE}/settings/services`,
  settingsTools: `/${BUSINESS_ROUTE}/settings/tools`,
  settingsEmbed: `/${BUSINESS_ROUTE}/settings/embed`,
  settingsBookingForm: `/${BUSINESS_ROUTE}/settings/booking-form`,
  billing: `/${BUSINESS_ROUTE}/billing`,
};

export function isBusinessShellRoute(url: string): boolean {
  return /^\/business(?:[/?#]|$)/.test(url || '');
}
